import dynamic from 'next/dynamic';

export const AddCircleOutlineOutlined = dynamic(() =>
	import(/* webpackChunkName:"AddCircleOutlineOutlined" */ '@mui/icons-material/AddCircleOutlineOutlined').then(
		(mod) => mod.default
	)
);
export const AdditionalServices = dynamic(() =>
	import(/* webpackChunkName:"AdditionalServices" */ './AdditionalServices').then((mod) => mod.default)
);
export const Allergy = dynamic(() => import(/* webpackChunkName:"Allergy" */ './Allergy').then((mod) => mod.default));
export const Apple = dynamic(() => import(/* webpackChunkName:"Apple" */ './Apple').then((mod) => mod.default));
export const AppleOnDark = dynamic(() =>
	import(/* webpackChunkName:"AppleOnDark" */ './AppleOnDark').then((mod) => mod.default)
);
export const ArrowButton = dynamic(() =>
	import(/* webpackChunkName:"ArrowButton" */ './ArrowButton').then((mod) => mod.default)
);
export const ArrowDown = dynamic(() =>
	import(/* webpackChunkName:"ArrowDown" */ './ArrowDown').then((mod) => mod.default)
);
export const ArrowDownFunc = dynamic(() =>
	import(/* webpackChunkName:"ArrowDownFunc" */ '@mui/icons-material/ArrowDownwardOutlined').then(
		(mod) => mod.default
	)
);
export const ArrowLeft = dynamic(() =>
	import(/* webpackChunkName:"ArrowLeft" */ './ArrowLeft').then((mod) => mod.default)
);
export const ArrowLeftFunc = dynamic(() =>
	import(/* webpackChunkName:"ArrowLeftFunc" */ '@mui/icons-material/ArrowBackOutlined').then((mod) => mod.default)
);
export const ArrowRight = dynamic(() =>
	import(/* webpackChunkName:"ArrowRight" */ './ArrowRight').then((mod) => mod.default)
);
export const ArrowRightFunc = dynamic(() =>
	import(/* webpackChunkName:"ArrowRightFunc" */ '@mui/icons-material/ArrowForwardOutlined').then(
		(mod) => mod.default
	)
);
export const ArrowRightMottoV2 = dynamic(() =>
	import(/* webpackChunkName:"ArrowRightMottoV2" */ './ArrowRightMottoV2').then((mod) => mod.default)
);
export const ArrowScrollToTop = dynamic(() =>
	import(/* webpackChunkName:"ArrowScrollToTop" */ './ArrowScrollToTop').then((mod) => mod.default)
);
export const ArrowUp = dynamic(() => import(/* webpackChunkName:"ArrowUp" */ './ArrowUp').then((mod) => mod.default));
export const ArrowUpFunc = dynamic(() =>
	import(/* webpackChunkName:"ArrowUpFunc" */ '@mui/icons-material/ArrowUpwardOutlined').then((mod) => mod.default)
);
export const ArrowUpward = dynamic(() =>
	import(/* webpackChunkName:"ArrowUpward" */ './ArrowUpward').then((mod) => mod.default)
);
export const ArrowUpwardOndark = dynamic(() =>
	import(/* webpackChunkName:"ArrowUpwardOndark" */ './ArrowUpward').then((mod) => mod.default)
);
export const AspenChatIcon = dynamic(() =>
	import(/* webpackChunkName:"AspenChatIcon" */ './AspenChatIcon').then((mod) => mod.default)
);
export const AspenChatLogoWhite = dynamic(() =>
	import(/* webpackChunkName:"AspenChatLogoWhite" */ './AspenChatLogoWhite').then((mod) => mod.default)
);

export { default as AspenDentalMapPinDark } from './AspenDentalMapPinDark';
export { default as AspenDentalMapPinLight } from './AspenDentalMapPinLight';

export const AspenOffice = dynamic(() =>
	import(/* webpackChunkName:"AspenOffice" */ './AspenOffice').then((mod) => mod.default)
);

export const AspenDentalBrandLogo = dynamic(() =>
	import(/* webpackChunkName:"AspenOffice" */ './AspenDentalBrandLogo').then((mod) => mod.default)
);

export const TeamTagAspenDentalLogo = dynamic(() =>
	import(/* webpackChunkName:"AspenOffice" */ './TeamTagAspenDentalLogo').then((mod) => mod.default)
);

export const LovetBrandLogo = dynamic(() =>
	import(/* webpackChunkName:"AspenOffice" */ './loveticons/LovetBrandLogo').then((mod) => mod.default)
);

export const AspenOfficeLocation = dynamic(() =>
	import(/* webpackChunkName:"AspenOfficeLocation" */ './AspenOfficeLocation').then((mod) => mod.default)
);
export const Asthma = dynamic(() => import(/* webpackChunkName:"Asthma" */ './Asthma').then((mod) => mod.default));

export const BadBreath = dynamic(() =>
	import(/* webpackChunkName:"BadBreath" */ './BadBreath').then((mod) => mod.default)
);
export const Bite = dynamic(() => import(/* webpackChunkName:"Bite" */ './Bite').then((mod) => mod.default));
export const Bars = dynamic(() =>
	import(/* webpackChunkName:"Bars" */ '@mui/icons-material/MenuOutlined').then((mod) => mod.default)
);
export const Bell = dynamic(() =>
	import(/* webpackChunkName:"Bell" */ '@mui/icons-material/NotificationsNoneOutlined').then((mod) => mod.default)
);
export const Bridge = dynamic(() => import(/* webpackChunkName:"Bridge" */ './Bridge').then((mod) => mod.default));
export const LVBriefcasePlus = dynamic(() =>
	import(/* webpackChunkName:"LVBriefcasePlus" */ './loveticons/LVBriefcasePlus').then((mod) => mod.default)
);
export const BrokenTooth = dynamic(() =>
	import(/* webpackChunkName:"BrokenTooth" */ './BrokenTooth').then((mod) => mod.default)
);
export const BudgetFriendly = dynamic(() =>
	import(/* webpackChunkName:"BudgetFriendly" */ './BudgetFriendly').then((mod) => mod.default)
);
export const Calendar = dynamic(() =>
	import(/* webpackChunkName:"Calendar" */ '@mui/icons-material/CalendarTodayOutlined').then((mod) => mod.default)
);
export const CalendarAlt = dynamic(() =>
	import(/* webpackChunkName:"CalendarAlt" */ '@mui/icons-material/DateRangeOutlined').then((mod) => mod.default)
);
export const CalendarDate = dynamic(() =>
	import(/* webpackChunkName:"CalendarDate" */ './CalendarDate').then((mod) => mod.default)
);
export const CalendarDateTime = dynamic(() =>
	import(/* webpackChunkName:"CalendarDateTime" */ './CalendarDateTime').then((mod) => mod.default)
);
export const CalendarDay = dynamic(() =>
	import(/* webpackChunkName:"CalendarDay" */ '@mui/icons-material/TodayOutlined').then((mod) => mod.default)
);
export const CalendarWeek = dynamic(() =>
	import(/* webpackChunkName:"CalendarWeek" */ '@mui/icons-material/EventNoteOutlined').then((mod) => mod.default)
);
export const Call = dynamic(() => import(/* webpackChunkName:"Call" */ './Call').then((mod) => mod.default));
export const CallIcon = dynamic(() =>
	import(/* webpackChunkName:"CallIcon" */ '@mui/icons-material/Call').then((mod) => mod.default)
);
export const Camera = dynamic(() => import(/* webpackChunkName:"Camera" */ './Camera').then((mod) => mod.default));
export const CameraOnDark = dynamic(() =>
	import(/* webpackChunkName:"CameraOnDark" */ './CameraOnDark').then((mod) => mod.default)
);
export const CCAward = dynamic(() => import(/* webpackChunkName:"CCAward" */ './CCAward').then((mod) => mod.default));
export const CCCare = dynamic(() => import(/* webpackChunkName:"CCCare" */ './CCCare').then((mod) => mod.default));
export const CCCheckmark = dynamic(() =>
	import(/* webpackChunkName:"CCCheckmark" */ './CCCheckmark').then((mod) => mod.default)
);
export const CCConfidence = dynamic(() =>
	import(/* webpackChunkName:"CCConfidence" */ './CCConfidence').then((mod) => mod.default)
);
export const CCDentistFemale = dynamic(() =>
	import(/* webpackChunkName:"CCDentistFemale" */ './CCDentistFemale').then((mod) => mod.default)
);
export const CCDentistMale = dynamic(() =>
	import(/* webpackChunkName:"CCDentistMale" */ './CCDentistMale').then((mod) => mod.default)
);
export const CCDenturesVsImplants = dynamic(() =>
	import(/* webpackChunkName:"CCDenturesVsImplants" */ './CCDenturesVsImplants').then((mod) => mod.default)
);
export const CCExactCost = dynamic(() =>
	import(/* webpackChunkName:"CCExactCost" */ './CCExactCost').then((mod) => mod.default)
);
export const CCInvestment = dynamic(() =>
	import(/* webpackChunkName:"CCInvestment" */ './CCInvestment').then((mod) => mod.default)
);
export const CCMaterialChoice = dynamic(() =>
	import(/* webpackChunkName:"CCMaterialChoice" */ './CCMaterialChoice').then((mod) => mod.default)
);
export const CCNewSmile = dynamic(() =>
	import(/* webpackChunkName:"CCNewSmile" */ './CCNewSmile').then((mod) => mod.default)
);
export const CCOffice = dynamic(() =>
	import(/* webpackChunkName:"CCOffice" */ './CCOffice').then((mod) => mod.default)
);
export const CCPaymentPlan = dynamic(() =>
	import(/* webpackChunkName:"CCPaymentPlan" */ './CCPaymentPlan').then((mod) => mod.default)
);
export const CCPermanentFix = dynamic(() =>
	import(/* webpackChunkName:"CCPermanentFix" */ './CCPermanentFix').then((mod) => mod.default)
);
export const CCProcedureComplexity = dynamic(() =>
	import(/* webpackChunkName:"CCProcedureComplexity" */ './CCProcedureComplexity').then((mod) => mod.default)
);
export const CCSmile = dynamic(() => import(/* webpackChunkName:"CCSmile" */ './CCSmile').then((mod) => mod.default));
export const CCSparkleTooth = dynamic(() =>
	import(/* webpackChunkName:"CCSparkleTooth" */ './CCSparkleTooth').then((mod) => mod.default)
);
export const CCTransform = dynamic(() =>
	import(/* webpackChunkName:"CCTransform" */ './CCTransform').then((mod) => mod.default)
);
export const CCTreatmentPlan = dynamic(() =>
	import(/* webpackChunkName:"CCTreatmentPlan" */ './CCTreatmentPlan').then((mod) => mod.default)
);
export const CCTreatmentType = dynamic(() =>
	import(/* webpackChunkName:"CCTreatmentType" */ './CCTreatmentType').then((mod) => mod.default)
);
export const CHBookNow = dynamic(() =>
	import(/* webpackChunkName:"CHBookNow" */ './CHBookNow').then((mod) => mod.default)
);
export const CHShopProducts = dynamic(() =>
	import(/* webpackChunkName:"CHShopProducts" */ './CHShopProducts').then((mod) => mod.default)
);
export const CHTakeOurQuiz = dynamic(() =>
	import(/* webpackChunkName:"CHTakeOurQuiz" */ './CHTakeOurQuiz').then((mod) => mod.default)
);

export { default as ChapterMapPinDark } from './ChapterMapPinDark';
export { default as ChapterMapPinLight } from './ChapterMapPinLight';

export const TeamTagChapterLogo = dynamic(() =>
	import(/* webpackChunkName:"CheckDefault" */ './TeamTagChapterLogo').then((mod) => mod.default)
);
export const Chat = dynamic(() => import(/* webpackChunkName:"Chat" */ './Chat').then((mod) => mod.default));
export const ChatBubbleOutline = dynamic(() =>
	import(/* webpackChunkName:"ChatBubbleOutline" */ '@mui/icons-material/ChatBubbleOutline').then(
		(mod) => mod.default
	)
);

export const ChapterBrandLogo = dynamic(() =>
	import(/* webpackChunkName:"AspenOffice" */ './ChapterBrandLogo').then((mod) => mod.default)
);

export const Check = dynamic(() => import(/* webpackChunkName:"Check" */ './Check').then((mod) => mod.default));
export const CheckDefault = dynamic(() =>
	import(/* webpackChunkName:"CheckDefault" */ './CheckDefault').then((mod) => mod.default)
);
export const CheckFunc = dynamic(() =>
	import(/* webpackChunkName:"CheckFunc" */ '@mui/icons-material/CheckOutlined').then((mod) => mod.default)
);
export const CheckSquare = dynamic(() =>
	import(/* webpackChunkName:"CheckSquare" */ './CheckSquare').then((mod) => mod.default)
);
export const CheckSquareFunc = dynamic(() =>
	import(/* webpackChunkName:"CheckSquareFunc" */ '@mui/icons-material/CheckBoxOutlined').then((mod) => mod.default)
);
export const CheckUp = dynamic(() => import(/* webpackChunkName:"CheckUp" */ './CheckUp').then((mod) => mod.default));
export const ChevronDown = dynamic(() =>
	import(/* webpackChunkName:"ChevronDown" */ './ChevronDown').then((mod) => mod.default)
);
export const ChevronLeft = dynamic(() =>
	import(/* webpackChunkName:"ChevronLeft" */ './ChevronLeft').then((mod) => mod.default)
);
export const ChevronLeftFunc = dynamic(() =>
	import(/* webpackChunkName:"ChevronLeftFunc" */ '@mui/icons-material/KeyboardArrowLeftOutlined').then(
		(mod) => mod.default
	)
);
export const ChevronRight = dynamic(() =>
	import(/* webpackChunkName:"ChevronRight" */ './ChevronRight').then((mod) => mod.default)
);
export const ChevronRightFunc = dynamic(() =>
	import(/* webpackChunkName:"ChevronRightFunc" */ '@mui/icons-material/KeyboardArrowRightOutlined').then(
		(mod) => mod.default
	)
);
export const ChevronUp = dynamic(() =>
	import(/* webpackChunkName:"ChevronUp" */ './ChevronUp').then((mod) => mod.default)
);
export const CHZero = dynamic(() => /* webpackChunkName: "CHZero" */ import('./CHZero').then((mod) => mod.default));
export const CHOne = dynamic(() => /* webpackChunkName: "CHOne" */ import('./CHOne').then((mod) => mod.default));
export const CHTwo = dynamic(() => /* webpackChunkName: "CHTwo" */ import('./CHTwo').then((mod) => mod.default));
export const CHThree = dynamic(() => /* webpackChunkName: "CHThree" */ import('./CHThree').then((mod) => mod.default));
export const CHFour = dynamic(() => /* webpackChunkName: "CHFour" */ import('./CHFour').then((mod) => mod.default));
export const CHFive = dynamic(() => /* webpackChunkName: "CHFive" */ import('./CHFive').then((mod) => mod.default));
export const CHSix = dynamic(() => /* webpackChunkName: "CHSix" */ import('./CHSix').then((mod) => mod.default));
export const CHSeven = dynamic(() => /* webpackChunkName: "CHSeven" */ import('./CHSeven').then((mod) => mod.default));
export const CHEight = dynamic(() => /* webpackChunkName: "CHEight" */ import('./CHEight').then((mod) => mod.default));
export const CHNine = dynamic(() => import(/* webpackChunkName:"CHNine" */ './CHNine').then((mod) => mod.default));
export const CHResults = dynamic(() =>
	/* webpackChunkName: "CHResults" */ import('./CHResults').then((mod) => mod.default)
);
export const CHPill = dynamic(() => /* webpackChunkName: "CHPill" */ import('./CHPill').then((mod) => mod.default));
export const CHFacial = dynamic(() =>
	/* webpackChunkName: "CHFacial" */ import('./CHFacial').then((mod) => mod.default)
);
export const CHThumbsUp = dynamic(() =>
	/* webpackChunkName: "CHThumbsUp" */ import('./CHThumbsUp').then((mod) => mod.default)
);
export const CHLaserHairRemoval = dynamic(() =>
	/* webpackChunkName: "CHLaserHairRemoval" */ import('./CHLaserHairRemoval').then((mod) => mod.default)
);
export const CHExclaimationPoint = dynamic(() =>
	/* webpackChunkName: "CHExclaimationPoint" */ import('./CHExclaimationPoint').then((mod) => mod.default)
);
export const CHCare = dynamic(() => /* webpackChunkName: "CHCare" */ import('./CHCare').then((mod) => mod.default));
export const CHSkincareProducts = dynamic(() =>
	/* webpackChunkName: "CHSkincareProducts" */ import('./CHSkincareProducts').then((mod) => mod.default)
);
export const CHCoolSculpting = dynamic(() =>
	/* webpackChunkName: "CHCoolSculpting" */ import('./CHCoolSculpting').then((mod) => mod.default)
);
export const CHSpecialOffers = dynamic(() =>
	/* webpackChunkName: "CHSpecialOffers" */ import('./CHSpecialOffers').then((mod) => mod.default)
);
export const CHDermaFillers = dynamic(() =>
	/* webpackChunkName: "CHDermaFillers" */ import('./CHDermaFillers').then((mod) => mod.default)
);
export const CHQuotes = dynamic(() =>
	/* webpackChunkName: "CHQuotes" */ import('./CHQuotes').then((mod) => mod.default)
);
export const CHQuiz = dynamic(() => /* webpackChunkName: "CHQuiz" */ import('./CHQuiz').then((mod) => mod.default));
export const CHRewardsClub = dynamic(() =>
	/* webpackChunkName: "CHRewardsClub" */ import('./CHRewardsClub').then((mod) => mod.default)
);
export const CHInjections = dynamic(() =>
	/* webpackChunkName: "CHInjections" */ import('./CHInjections').then((mod) => mod.default)
);
export const CHHelp = dynamic(() => /* webpackChunkName: "CHHelp" */ import('./CHHelp').then((mod) => mod.default));
export const CHLocation = dynamic(() =>
	/* webpackChunkName: "CHOffers" */ import('./CHLocation').then((mod) => mod.default)
);
export const CHCheckmark = dynamic(() =>
	/* webpackChunkName: "CHCheckmark" */ import('./CHCheckmark').then((mod) => mod.default)
);
export const CHOffers = dynamic(() =>
	/* webpackChunkName: "CHOffers" */ import('./CHOffers').then((mod) => mod.default)
);
export const CHTechnology = dynamic(() =>
	/* webpackChunkName: "CHTechnology" */ import('./CHTechnology').then((mod) => mod.default)
);
export const CHGiftCard = dynamic(() =>
	/* webpackChunkName: "CHGiftCard" */ import('./CHGiftCard').then((mod) => mod.default)
);
export const CHReferAFriend = dynamic(() =>
	/* webpackChunkName: "CHReferAFriend" */ import('./CHReferAFriend').then((mod) => mod.default)
);

export const CircleCheckWhite = dynamic(() =>
	import(/* webpackChunkName:"CircleCheckWhite" */ './CircleCheckWhite').then((mod) => mod.default)
);
export const CircleCheckWhiteOnDark = dynamic(() =>
	import(/* webpackChunkName:"CircleCheckWhiteOnDark" */ './CircleCheckWhite').then((mod) => mod.default)
);
export const CircleError = dynamic(() =>
	import(/* webpackChunkName:"CircleError" */ '@mui/icons-material/HighlightOffOutlined').then((mod) => mod.default)
);
export const CircleInfo = dynamic(() =>
	import(/* webpackChunkName:"CircleInfo" */ '@mui/icons-material/InfoOutlined').then((mod) => mod.default)
);
export const CircleQuestion = dynamic(() =>
	import(/* webpackChunkName:"CircleQuestion" */ '@mui/icons-material/HelpOutline').then((mod) => mod.default)
);
export const CircleWarning = dynamic(() =>
	import(/* webpackChunkName:"CircleWarning" */ '@mui/icons-material/ErrorOutlineOutlined').then((mod) => mod.default)
);

export { default as ClearChoiceMapPinDark } from './ClearChoiceMapPinDark';
export { default as ClearChoiceMapPinLight } from './ClearChoiceMapPinLight';

export const Clear = dynamic(() => import(/* webpackChunkName:"Clear" */ './Clear').then((mod) => mod.default));

export const ClearChoiceBrandLogo = dynamic(() =>
	import(/* webpackChunkName:"AspenOffice" */ './ClearChoiceBrandLogo').then((mod) => mod.default)
);

export const TeamTagClearChoiceLogo = dynamic(() =>
	import(/* webpackChunkName:"AspenOffice" */ './TeamTagClearChoiceLogo').then((mod) => mod.default)
);

export const Clipboard = dynamic(() =>
	import(/* webpackChunkName:"Clipboard" */ './Clipboard').then((mod) => mod.default)
);

export const ClipboardListCheck = dynamic(() =>
	import(/* webpackChunkName:"ClipboardListCheck" */ '@mui/icons-material/ContentPasteOutlined').then(
		(mod) => mod.default
	)
);
export const Clock = dynamic(() =>
	import(/* webpackChunkName:"Clock" */ '@mui/icons-material/AccessTime').then((mod) => mod.default)
);
export const Covid19 = dynamic(() => import(/* webpackChunkName:"Covid19" */ './Covid19').then((mod) => mod.default));
export const CricleSuccess = dynamic(() =>
	import(/* webpackChunkName:"CricleSuccess" */ '@mui/icons-material/CheckCircleOutlineOutlined').then(
		(mod) => mod.default
	)
);
export const Crown = dynamic(() => import(/* webpackChunkName:"Crown" */ './Crown').then((mod) => mod.default));
export const Customization = dynamic(() =>
	import(/* webpackChunkName:"Customization" */ './Customization').then((mod) => mod.default)
);
export const CustomizationOnDark = dynamic(() =>
	import(/* webpackChunkName:"CustomizationOnDark" */ './CustomizationOnDark').then((mod) => mod.default)
);
export const DentalChair = dynamic(() =>
	import(/* webpackChunkName:"DentalChair" */ './DentalChair').then((mod) => mod.default)
);
export const DentalChairOnDark = dynamic(() =>
	import(/* webpackChunkName:"DentalChairOnDark" */ './DentalChairOnDark').then((mod) => mod.default)
);
export const DentalOffice = dynamic(() =>
	import(/* webpackChunkName:"DentalOffice" */ './DentalOffice').then((mod) => mod.default)
);
export const Dentures = dynamic(() =>
	import(/* webpackChunkName:"Dentures" */ './Dentures').then((mod) => mod.default)
);
export const DentureSolution = dynamic(() =>
	import(/* webpackChunkName:"DentureSolution" */ './DentureSolution').then((mod) => mod.default)
);
export const DentureSolutionOnDark = dynamic(() =>
	import(/* webpackChunkName:"DentureSolutionOnDark" */ './DentureSolution').then((mod) => mod.default)
);
export const DentureWithBrush = dynamic(() =>
	import(/* webpackChunkName:"DentureWithBrush" */ './DentureWithBrush').then((mod) => mod.default)
);
export const DentureWithBrushOnDark = dynamic(() =>
	import(/* webpackChunkName:"DentureWithBrushOnDark" */ './DentureWithBrush').then((mod) => mod.default)
);
export const Desktop = dynamic(() =>
	import(/* webpackChunkName:"Desktop" */ '@mui/icons-material/DesktopMacOutlined').then((mod) => mod.default)
);
export const DiamondWhite = dynamic(() =>
	import(/* webpackChunkName:"DiamondWhite" */ './DiamondWhite').then((mod) => mod.default)
);
export const DiamondLight = dynamic(() =>
	import(/* webpackChunkName:"DiamondLight" */ './DiamondLight').then((mod) => mod.default)
);
export const Discoloration = dynamic(() =>
	import(/* webpackChunkName:"Discoloration" */ './Discoloration').then((mod) => mod.default)
);
export const DiscolorationOnDark = dynamic(() =>
	import(/* webpackChunkName:"DiscolorationOnDark" */ './Discoloration').then((mod) => mod.default)
);
export const Discord = dynamic(() => import(/* webpackChunkName:"Discord" */ './Discord').then((mod) => mod.default));
export const Download = dynamic(() =>
	import(/* webpackChunkName:"Download" */ './Download').then((mod) => mod.default)
);
export const DownloadFunc = dynamic(() =>
	import(/* webpackChunkName:"DownloadFunc" */ '@mui/icons-material/DownloadOutlined').then((mod) => mod.default)
);
export const Eczema = dynamic(() => import(/* webpackChunkName:"Eczema" */ './Eczema').then((mod) => mod.default));
export const Edit = dynamic(() =>
	import(/* webpackChunkName:"Edit" */ '@mui/icons-material/ModeEditOutlineOutlined').then((mod) => mod.default)
);
export const Education = dynamic(() =>
	import(/* webpackChunkName:"Education" */ './Education').then((mod) => mod.default)
);
export const EllipsisH = dynamic(() =>
	import(/* webpackChunkName:"EllipsisH" */ '@mui/icons-material/MoreHoriz').then((mod) => mod.default)
);
export const EllipsisHAlt = dynamic(() =>
	import(/* webpackChunkName:"EllipsisHAlt" */ './EllipsisHAlt').then((mod) => mod.default)
);
export const EllipsisV = dynamic(() =>
	import(/* webpackChunkName:"EllipsisV" */ '@mui/icons-material/MoreVert').then((mod) => mod.default)
);
export const EllipsisVAlt = dynamic(() =>
	import(/* webpackChunkName:"EllipsisVAlt" */ './EllipsisVAlt').then((mod) => mod.default)
);
export const Email = dynamic(() => import(/* webpackChunkName:"Email" */ './Email').then((mod) => mod.default));
export const SolidEmail = dynamic(() =>
	import(/* webpackChunkName:"SolidEmail" */ '@mui/icons-material/Email').then((mod) => mod.default)
);
export const Emergency = dynamic(() =>
	import(/* webpackChunkName:"Emergency" */ './Emergency').then((mod) => mod.default)
);
export const EnvironmentalAllergy = dynamic(() =>
	import(/* webpackChunkName:"EnvironmentalAllergy" */ './EnvironmentalAllergy').then((mod) => mod.default)
);
export const ErrorCircle = dynamic(() =>
	import(/* webpackChunkName:"ErrorCircle" */ './ErrorCircle').then((mod) => mod.default)
);
export const ExternalLink = dynamic(() =>
	import(/* webpackChunkName:"ExternalLink" */ '@mui/icons-material/LaunchOutlined').then((mod) => mod.default)
);
export const Eye = dynamic(() =>
	import(/* webpackChunkName:"Eye" */ '@mui/icons-material/RemoveRedEyeOutlined').then((mod) => mod.default)
);
export const EyeSlash = dynamic(() =>
	import(/* webpackChunkName:"EyeSlash" */ '@mui/icons-material/VisibilityOffOutlined').then((mod) => mod.default)
);
export const Facebook = dynamic(() =>
	import(/* webpackChunkName:"Facebook" */ './Facebook').then((mod) => mod.default)
);

export { default as FallBackMapPinDark } from './FallBackMapPinDark';
export { default as FallBackMapPinLight } from './FallBackMapPinLight';

export const Fax = dynamic(() =>
	import(/* webpackChunkName:"Fax" */ '@mui/icons-material/Fax').then((mod) => mod.default)
);
export const Feather = dynamic(() => import(/* webpackChunkName:"Feather" */ './Feather').then((mod) => mod.default));
export const FeatherOnDark = dynamic(() =>
	import(/* webpackChunkName:"FeatherOnDark" */ './FeatherOnDark').then((mod) => mod.default)
);
export const Filling = dynamic(() => import(/* webpackChunkName:"Filling" */ './Filling').then((mod) => mod.default));
export const Filter = dynamic(() => import(/* webpackChunkName:"Filter" */ './Filter').then((mod) => mod.default));
export const FilterFunc = dynamic(() =>
	import(/* webpackChunkName:"FilterFunc" */ '@mui/icons-material/FilterAltOutlined').then((mod) => mod.default)
);
export const Financing = dynamic(() =>
	import(/* webpackChunkName:"Financing" */ './Financing').then((mod) => mod.default)
);
export const FinishFlag = dynamic(() =>
	import(/* webpackChunkName:"FinishFlag" */ './FinishFlag').then((mod) => mod.default)
);
export const FinishFlagOnDark = dynamic(() =>
	import(/* webpackChunkName:"FinishFlagOnDark" */ './FinishFlagOnDark').then((mod) => mod.default)
);
export const FirstAid = dynamic(() =>
	import(/* webpackChunkName:"FirstAid" */ './FirstAid').then((mod) => mod.default)
);
export const FirstAidOnDark = dynamic(() =>
	import(/* webpackChunkName:"FirstAidOnDark" */ './FirstAid').then((mod) => mod.default)
);
export const FittedTooth = dynamic(() =>
	import(/* webpackChunkName:"FittedTooth" */ './FittedTooth').then((mod) => mod.default)
);
export const FlagMX = dynamic(() => import(/* webpackChunkName:"FlagMX" */ './FlagMX').then((mod) => mod.default));
export const FlagUS = dynamic(() => import(/* webpackChunkName:"FlagUS" */ './FlagUS').then((mod) => mod.default));
export const FittedToothOnDark = dynamic(() =>
	import(/* webpackChunkName:"FittedToothOnDark" */ './FittedToothOnDark').then((mod) => mod.default)
);
export const FolderOpen = dynamic(() =>
	import(/* webpackChunkName:"FolderOpen" */ '@mui/icons-material/FolderOutlined').then((mod) => mod.default)
);
export const FoodAllergy = dynamic(() =>
	import(/* webpackChunkName:"FoodAllergy" */ './FoodAllergy').then((mod) => mod.default)
);
export const Forms = dynamic(() => import(/* webpackChunkName:"Forms" */ './Forms').then((mod) => mod.default));
export const FullDenture = dynamic(() =>
	import(/* webpackChunkName:"FullDenture" */ './FullDenture').then((mod) => mod.default)
);
export const Goggles = dynamic(() => import(/* webpackChunkName:"Goggles" */ './Goggles').then((mod) => mod.default));
export const Gum = dynamic(() => import(/* webpackChunkName:"Gum" */ './Gum').then((mod) => mod.default));
export const HappinessCheck = dynamic(() =>
	import(/* webpackChunkName:"HappinessCheck" */ './HappinessCheck').then((mod) => mod.default)
);
export const HappinessCheckOnDark = dynamic(() =>
	import(/* webpackChunkName:"HappinessCheckOnDark" */ './HappinessCheck').then((mod) => mod.default)
);
export const Heart = dynamic(() => import(/* webpackChunkName:"Heart" */ './Heart').then((mod) => mod.default));
export const HeartOnDark = dynamic(() =>
	import(/* webpackChunkName:"HeartOnDark" */ './HeartOnDark').then((mod) => mod.default)
);
export const Illnesses = dynamic(() =>
	import(/* webpackChunkName:"Illnesses" */ './Illnesses').then((mod) => mod.default)
);
export const Implant = dynamic(() => import(/* webpackChunkName:"Implant" */ './Implant').then((mod) => mod.default));
export const ImplantInBase = dynamic(() =>
	import(/* webpackChunkName:"ImplantInBase" */ './ImplantInBase').then((mod) => mod.default)
);
export const ImplantInBaseOnDark = dynamic(() =>
	import(/* webpackChunkName:"ImplantInBaseOnDark" */ './ImplantInBase').then((mod) => mod.default)
);
export const InfoCircle = dynamic(() =>
	import(/* webpackChunkName:"InfoCircle" */ './InfoCircle').then((mod) => mod.default)
);
export const Injury = dynamic(() => import(/* webpackChunkName:"Injury" */ './Injury').then((mod) => mod.default));
export const Invisalign = dynamic(() =>
	import(/* webpackChunkName:"Invisalign" */ './Invisalign').then((mod) => mod.default)
);
export const LightBulb = dynamic(() =>
	import(/* webpackChunkName:"LightBulb" */ './LightBulb').then((mod) => mod.default)
);
export const LightBulbOnDark = dynamic(() =>
	import(/* webpackChunkName:"LightBulbOnDark" */ './LightBulb').then((mod) => mod.default)
);
export const LinkedIn = dynamic(() =>
	import(/* webpackChunkName:"LinkedIn" */ './LinkedIn').then((mod) => mod.default)
);
export const Lips = dynamic(() => import(/* webpackChunkName:"Lips" */ './Lips').then((mod) => mod.default));
export const LipsWithSparkle = dynamic(() =>
	import(/* webpackChunkName:"LipsWithSparkle" */ './LipsWithSparkle').then((mod) => mod.default)
);
export const LocationArrow = dynamic(() =>
	import(/* webpackChunkName:"LocationArrow" */ '@mui/icons-material/NavigationOutlined').then((mod) => mod.default)
);
export const LocationRounded = dynamic(() =>
	import(/* webpackChunkName:"LocationRounded" */ '@mui/icons-material/GpsFixed').then((mod) => mod.default)
);
export const Longevity = dynamic(() =>
	import(/* webpackChunkName:"Longevity" */ './Longevity').then((mod) => mod.default)
);
export const LongevityOnDark = dynamic(() =>
	import(/* webpackChunkName:"LongevityOnDark" */ './LongevityOnDark').then((mod) => mod.default)
);

export const TeamTagLovetLogo = dynamic(() =>
	import(/* webpackChunkName:"LongevityOnDark" */ './TeamTagLovetLogo').then((mod) => mod.default)
);

export { default as LovetMapPinDark } from './loveticons/LovetMapPinDark';
export { default as LovetMapPinLight } from './loveticons/LovetMapPinLight';

export const LVCat = dynamic(() =>
	import(/* webpackChunkName:"LVCat" */ './loveticons/LVCatDark').then((mod) => mod.default)
);
export const LVDentistry = dynamic(() =>
	import(/* webpackChunkName:"LVDentistry" */ './loveticons/LVDentistry').then((mod) => mod.default)
);
export const LVDog = dynamic(() =>
	import(/* webpackChunkName:"LVDog" */ './loveticons/LVDogDark').then((mod) => mod.default)
);
export const LVExam = dynamic(() =>
	import(/* webpackChunkName:"LVExam" */ './loveticons/LVExam').then((mod) => mod.default)
);
export const LVHeart = dynamic(() =>
	import(/* webpackChunkName:"LVHeart" */ './loveticons/LVHeart').then((mod) => mod.default)
);
export const LVOtherPet = dynamic(() =>
	import(/* webpackChunkName:"LVOtherPet" */ './loveticons/LVOtherPetDark').then((mod) => mod.default)
);
export const LVPetType = dynamic(() =>
	import(/* webpackChunkName:"LVPetType" */ './loveticons/LVPetTypeDark').then((mod) => mod.default)
);
export const LVSpay = dynamic(() =>
	import(/* webpackChunkName:"LVSpay" */ './loveticons/LVSpay').then((mod) => mod.default)
);
export const LVStethoscope = dynamic(() =>
	import(/* webpackChunkName:"LVStethoscope" */ './loveticons/LVStethoscope').then((mod) => mod.default)
);
export const LVUltrasound = dynamic(() =>
	import(/* webpackChunkName:"LVUltrasound" */ './loveticons/LVUltrasound').then((mod) => mod.default)
);
export const LVVaccination = dynamic(() =>
	import(/* webpackChunkName:"LVVaccination" */ './loveticons/LVVaccination').then((mod) => mod.default)
);
export const LVWellness = dynamic(() =>
	import(/* webpackChunkName:"LVWellness" */ './loveticons/LVWellness').then((mod) => mod.default)
);
// Lovet converted icons
export const LVAdvancedServicesDark = dynamic(() =>
	/* webpackChunkName: "LVAdvancedServicesDark" */ import('./loveticons/LVAdvancedServicesDark').then(
		(mod) => mod.default
	)
);
export const LVAdvancedServicesLight = dynamic(() =>
	/* webpackChunkName: "LVAdvancedServicesLight" */ import('./loveticons/LVAdvancedServicesLight').then(
		(mod) => mod.default
	)
);
export const LVAlertDark = dynamic(() =>
	/* webpackChunkName: "LVAlertDark" */ import('./loveticons/LVAlertDark').then((mod) => mod.default)
);
export const LVAlertLight = dynamic(() =>
	/* webpackChunkName: "LVAlertLight" */ import('./loveticons/LVAlertLight').then((mod) => mod.default)
);
export const LVAnnouncementDark = dynamic(() =>
	/* webpackChunkName: "LVAnnouncementDark" */ import('./loveticons/LVAnnouncementDark').then((mod) => mod.default)
);
export const LVAnnouncementLight = dynamic(() =>
	/* webpackChunkName: "LVAnnouncementLight" */ import('./loveticons/LVAnnouncementLight').then((mod) => mod.default)
);
export const LVAwardDark = dynamic(() =>
	/* webpackChunkName: "LVAwardDark" */ import('./loveticons/LVAwardDark').then((mod) => mod.default)
);
export const LVAwardLight = dynamic(() =>
	/* webpackChunkName: "LVAwardLight" */ import('./loveticons/LVAwardLight').then((mod) => mod.default)
);
export const LVCalendarDark = dynamic(() =>
	/* webpackChunkName: "LVCalendarDark" */ import('./loveticons/LVCalendarDark').then((mod) => mod.default)
);
export const LVCalendarLight = dynamic(() =>
	/* webpackChunkName: "LVCalendarLight" */ import('./loveticons/LVCalendarLight').then((mod) => mod.default)
);
export const LVCareDark = dynamic(() =>
	/* webpackChunkName: "LVCareDark" */ import('./loveticons/LVCareDark').then((mod) => mod.default)
);
export const LVCareLight = dynamic(() =>
	/* webpackChunkName: "LVCareLight" */ import('./loveticons/LVCareLight').then((mod) => mod.default)
);
export const LVCatDark = dynamic(() =>
	/* webpackChunkName: "LVCatDark" */ import('./loveticons/LVCatDark').then((mod) => mod.default)
);
export const LVCatLight = dynamic(() =>
	/* webpackChunkName: "LVCatLight" */ import('./loveticons/LVCatLight').then((mod) => mod.default)
);
export const LVCheckmarkDark = dynamic(() =>
	/* webpackChunkName: "LVCheckmarkDark" */ import('./loveticons/LVCheckmarkDark').then((mod) => mod.default)
);
export const LVCheckmarkLight = dynamic(() =>
	/* webpackChunkName: "LVCheckmarkLight" */ import('./loveticons/LVCheckmarkLight').then((mod) => mod.default)
);
export const LVClipboardDark = dynamic(() =>
	/* webpackChunkName: "LVClipboardDark" */ import('./loveticons/LVClipboardDark').then((mod) => mod.default)
);
export const LVClipboardLight = dynamic(() =>
	/* webpackChunkName: "LVClipboardLight" */ import('./loveticons/LVClipboardLight').then((mod) => mod.default)
);
export const LVDentalDark = dynamic(() =>
	/* webpackChunkName: "LVDentalDark" */ import('./loveticons/LVDentalDark').then((mod) => mod.default)
);
export const LVDentalLight = dynamic(() =>
	/* webpackChunkName: "LVDentalLight" */ import('./loveticons/LVDentalLight').then((mod) => mod.default)
);
export const LVDogDark = dynamic(() =>
	/* webpackChunkName: "LVDogDark" */ import('./loveticons/LVDogDark').then((mod) => mod.default)
);
export const LVDogLight = dynamic(() =>
	/* webpackChunkName: "LVDogLight" */ import('./loveticons/LVDogLight').then((mod) => mod.default)
);
export const LVEducationDark = dynamic(() =>
	/* webpackChunkName: "LVEducationDark" */ import('./loveticons/LVEducationDark').then((mod) => mod.default)
);
export const LVEducationLight = dynamic(() =>
	/* webpackChunkName: "LVEducationLight" */ import('./loveticons/LVEducationLight').then((mod) => mod.default)
);
export const LVGlyphDark = dynamic(() =>
	/* webpackChunkName: "LVGlyphDark" */ import('./loveticons/LVGlyphDark').then((mod) => mod.default)
);
export const LVGlyphLight = dynamic(() =>
	/* webpackChunkName: "LVGlyphLight" */ import('./loveticons/LVGlyphLight').then((mod) => mod.default)
);
export const LVLocationDark = dynamic(() =>
	/* webpackChunkName: "LVLocationDark" */ import('./loveticons/LVLocationDark').then((mod) => mod.default)
);
export const LVLocationLight = dynamic(() =>
	/* webpackChunkName: "LVLocationLight" */ import('./loveticons/LVLocationLight').then((mod) => mod.default)
);
export const LVMagnifyingGlassDark = dynamic(() =>
	/* webpackChunkName: "LVMagnifyingGlassDark" */ import('./loveticons/LVMagnifyingGlassDark').then(
		(mod) => mod.default
	)
);
export const LVMagnifyingGlassLight = dynamic(() =>
	/* webpackChunkName: "LVMagnifyingGlassLight" */ import('./loveticons/LVMagnifyingGlassLight').then(
		(mod) => mod.default
	)
);
export const LVMedicationDark = dynamic(() =>
	/* webpackChunkName: "LVMedicationDark" */ import('./loveticons/LVMedicationDark').then((mod) => mod.default)
);
export const LVMedicationLight = dynamic(() =>
	/* webpackChunkName: "LVMedicationLight" */ import('./loveticons/LVMedicationLight').then((mod) => mod.default)
);
export const LVMoneyDark = dynamic(() =>
	/* webpackChunkName: "LVMoneyDark" */ import('./loveticons/LVMoneyDark').then((mod) => mod.default)
);
export const LVMoneyLight = dynamic(() =>
	/* webpackChunkName: "LVMoneyLight" */ import('./loveticons/LVMoneyLight').then((mod) => mod.default)
);
export const LVMultipleUsersDark = dynamic(() =>
	/* webpackChunkName: "LVMultipleUsersDark" */ import('./loveticons/LVMultipleUsersDark').then((mod) => mod.default)
);
export const LVMultipleUsersLight = dynamic(() =>
	/* webpackChunkName: "LVMultipleUsersLight" */ import('./loveticons/LVMultipleUsersLight').then(
		(mod) => mod.default
	)
);
export const LVNewLocationDark = dynamic(() =>
	/* webpackChunkName: "LVNewLocationDark" */ import('./loveticons/LVNewLocationDark').then((mod) => mod.default)
);
export const LVNewLocationLight = dynamic(() =>
	/* webpackChunkName: "LVNewLocationLight" */ import('./loveticons/LVNewLocationLight').then((mod) => mod.default)
);
export const LVOtherPetDark = dynamic(() =>
	/* webpackChunkName: "LVOtherPetDark" */ import('./loveticons/LVOtherPetDark').then((mod) => mod.default)
);
export const LVOtherPetLight = dynamic(() =>
	/* webpackChunkName: "LVOtherPetLight" */ import('./loveticons/LVOtherPetLight').then((mod) => mod.default)
);
export const LVPaymentPlansDark = dynamic(() =>
	/* webpackChunkName: "LVPaymentPlansDark" */ import('./loveticons/LVPaymentPlansDark').then((mod) => mod.default)
);
export const LVPaymentPlansLight = dynamic(() =>
	/* webpackChunkName: "LVPaymentPlansLight" */ import('./loveticons/LVPaymentPlansLight').then((mod) => mod.default)
);
export const LVPeaceOfMindDark = dynamic(() =>
	/* webpackChunkName: "LVPeaceOfMindDark" */ import('./loveticons/LVPeaceOfMindDark').then((mod) => mod.default)
);
export const LVPeaceOfMindLight = dynamic(() =>
	/* webpackChunkName: "LVPeaceOfMindLight" */ import('./loveticons/LVPeaceOfMindLight').then((mod) => mod.default)
);
export const LVPetTypeDark = dynamic(() =>
	/* webpackChunkName: "LVPetTypeDark" */ import('./loveticons/LVPetTypeDark').then((mod) => mod.default)
);
export const LVPetTypeLight = dynamic(() =>
	/* webpackChunkName: "LVPetTypeLight" */ import('./loveticons/LVPetTypeLight').then((mod) => mod.default)
);
export const LVPhoneDark = dynamic(() =>
	/* webpackChunkName: "LVPhoneDark" */ import('./loveticons/LVPhoneDark').then((mod) => mod.default)
);
export const LVPhoneLight = dynamic(() =>
	/* webpackChunkName: "LVPhoneLight" */ import('./loveticons/LVPhoneLight').then((mod) => mod.default)
);
export const LVPreventativeCareDark = dynamic(() =>
	/* webpackChunkName: "LVPreventativeCareDark" */ import('./loveticons/LVPreventativeCareDark').then(
		(mod) => mod.default
	)
);
export const LVPreventativeCareLight = dynamic(() =>
	/* webpackChunkName: "LVPreventativeCareLight" */ import('./loveticons/LVPreventativeCareLight').then(
		(mod) => mod.default
	)
);
export const LVPriorityDark = dynamic(() =>
	/* webpackChunkName: "LVPriorityDark" */ import('./loveticons/LVPriorityDark').then((mod) => mod.default)
);
export const LVPriorityLight = dynamic(() =>
	/* webpackChunkName: "LVPriorityLight" */ import('./loveticons/LVPriorityLight').then((mod) => mod.default)
);
export const LVQuestionDark = dynamic(() =>
	/* webpackChunkName: "LVQuestionDark" */ import('./loveticons/LVQuestionDark').then((mod) => mod.default)
);
export const LVQuestionLight = dynamic(() =>
	/* webpackChunkName: "LVQuestionLight" */ import('./loveticons/LVQuestionLight').then((mod) => mod.default)
);
export const LVSavingsDark = dynamic(() =>
	/* webpackChunkName: "LVSavingsDark" */ import('./loveticons/LVSavingsDark').then((mod) => mod.default)
);
export const LVSavingsLight = dynamic(() =>
	/* webpackChunkName: "LVSavingsLight" */ import('./loveticons/LVSavingsLight').then((mod) => mod.default)
);
export const LVSpayNeuterDark = dynamic(() =>
	/* webpackChunkName: "LVSpayNeuterDark" */ import('./loveticons/LVSpayNeuterDark').then((mod) => mod.default)
);
export const LVSpayNeuterLight = dynamic(() =>
	/* webpackChunkName: "LVSpayNeuterLight" */ import('./loveticons/LVSpayNeuterLight').then((mod) => mod.default)
);
export const LVSurgeryDark = dynamic(() =>
	/* webpackChunkName: "LVSurgeryDark" */ import('./loveticons/LVSurgeryDark').then((mod) => mod.default)
);
export const LVSurgeryLight = dynamic(() =>
	/* webpackChunkName: "LVSurgeryLight" */ import('./loveticons/LVSurgeryLight').then((mod) => mod.default)
);
export const LVTimeDark = dynamic(() =>
	/* webpackChunkName: "LVTimeDark" */ import('./loveticons/LVTimeDark').then((mod) => mod.default)
);
export const LVTimeLight = dynamic(() =>
	/* webpackChunkName: "LVTimeLight" */ import('./loveticons/LVTimeLight').then((mod) => mod.default)
);
export const LVUrgentCareDark = dynamic(() =>
	/* webpackChunkName: "LVUrgentCareDark" */ import('./loveticons/LVUrgentCareDark').then((mod) => mod.default)
);
export const LVUrgentCareLight = dynamic(() =>
	/* webpackChunkName: "LVUrgentCareLight" */ import('./loveticons/LVUrgentCareLight').then((mod) => mod.default)
);
export const LVVaccinationsDark = dynamic(() =>
	/* webpackChunkName: "LVVaccinationsDark" */ import('./loveticons/LVVaccinationsDark').then((mod) => mod.default)
);
export const LVVaccinationsLight = dynamic(() =>
	/* webpackChunkName: "LVVaccinationsLight" */ import('./loveticons/LVVaccinationsLight').then((mod) => mod.default)
);
export const LVWaveDark = dynamic(() =>
	/* webpackChunkName: "LVWaveDark" */ import('./loveticons/LVWaveDark').then((mod) => mod.default)
);
export const LVWaveLight = dynamic(() =>
	/* webpackChunkName: "LVWaveLight" */ import('./loveticons/LVWaveLight').then((mod) => mod.default)
);
export const Map = dynamic(() =>
	import(/* webpackChunkName:"Map" */ '@mui/icons-material/MapOutlined').then((mod) => mod.default)
);
export const MapPinSimple = dynamic(() =>
	import(/* webpackChunkName:"MapPinSimple" */ './MapPinSimple').then((mod) => mod.default)
);
export const MapMarker = dynamic(() =>
	import(/* webpackChunkName:"MapMarker" */ '@mui/icons-material/FmdGoodOutlined').then((mod) => mod.default)
);
export const MedicationAllergy = dynamic(() =>
	import(/* webpackChunkName:"MedicationAllergy" */ './MedicationAllergy').then((mod) => mod.default)
);
export const MicrophoneAlt = dynamic(() =>
	import(/* webpackChunkName:"MicrophoneAlt" */ '@mui/icons-material/MicNoneOutlined').then((mod) => mod.default)
);
export const Microscope = dynamic(() =>
	import(/* webpackChunkName:"Microscope" */ './Microscope').then((mod) => mod.default)
);
export const MicroscopeOnDark = dynamic(() =>
	import(/* webpackChunkName:"MicroscopeOnDark" */ './Microscope').then((mod) => mod.default)
);
export const Minus = dynamic(() => import(/* webpackChunkName:"Minus" */ './Minus').then((mod) => mod.default));
export const MinusFunc = dynamic(() =>
	import(/* webpackChunkName:"MinusFunc" */ '@mui/icons-material/HorizontalRuleOutlined').then((mod) => mod.default)
);
export const MissingTooth = dynamic(() =>
	import(/* webpackChunkName:"MissingTooth" */ './MissingTooth').then((mod) => mod.default)
);
export const Mobile = dynamic(() =>
	import(/* webpackChunkName:"Mobile" */ '@mui/icons-material/PhoneIphoneOutlined').then((mod) => mod.default)
);
export const MoneyBackGuarantee = dynamic(() =>
	import(/* webpackChunkName:"MoneyBackGuarantee" */ './MoneyBackGuarantee').then((mod) => mod.default)
);
export const MoneyBackGuaranteeOnDark = dynamic(() =>
	import(/* webpackChunkName:"MoneyBackGuaranteeOnDark" */ './MoneyBackGuaranteeOnDark').then((mod) => mod.default)
);
export const MoneyBackDarkBlue = dynamic(() =>
	import(/* webpackChunkName:"MoneyBackDarkBlue" */ './MoneyBackDarkBlue').then((mod) => mod.default)
);
export const MoneyInHand = dynamic(() =>
	import(/* webpackChunkName:"MoneyInHand" */ './MoneyInHand').then((mod) => mod.default)
);
export const MoneyInHandOnDark = dynamic(() =>
	import(/* webpackChunkName:"MoneyInHandOnDark" */ './MoneyInHand').then((mod) => mod.default)
);
export const MottoArrowAfter = dynamic(() =>
	import(/* webpackChunkName:"MottoArrowAfter" */ './MottoArrowAfter').then((mod) => mod.default)
);
export const MottoArrowBefore = dynamic(() =>
	import(/* webpackChunkName:"MottoArrowBefore" */ './MottoArrowBefore').then((mod) => mod.default)
);
export const MottoArrowRight = dynamic(() =>
	import(/* webpackChunkName:"MottoArrowRight" */ './MottoArrowRight').then((mod) => mod.default)
);
export const MottoBadgeLogo = dynamic(() =>
	import(/* webpackChunkName:"MottoBadgeLogo" */ './MottoBadgeLogo').then((mod) => mod.default)
);
export const MottoPlayCircleBtn = dynamic(() =>
	import(/* webpackChunkName:"MottoPlayCircleBtn" */ './MottoPlayCircleBtn').then((mod) => mod.default)
);
export const MottoQuotes = dynamic(() =>
	import(/* webpackChunkName:"MottoQuotes" */ './MottoQuotes').then((mod) => mod.default)
);
export { default as MottoClearAlignersMapPinDark } from './MottoClearAlignersMapPinDark';
export { default as MottoClearAlignersMapPinLight } from './MottoClearAlignersMapPinLight';
export const MyAccount = dynamic(() =>
	import(/* webpackChunkName:"MyAccount" */ './MyAccount').then((mod) => mod.default)
);
export const MyLocation = dynamic(() =>
	import(/* webpackChunkName:"MyLocation" */ './MyLocation').then((mod) => mod.default)
);
export const News = dynamic(() => import(/* webpackChunkName:"News" */ './News').then((mod) => mod.default));
export const NewsOnDark = dynamic(() =>
	import(/* webpackChunkName:"NewsOnDark" */ './News').then((mod) => mod.default)
);
export const NightTime = dynamic(() =>
	import(/* webpackChunkName:"NightTime" */ './NightTime').then((mod) => mod.default)
);
export const NightTimeOnDark = dynamic(() =>
	import(/* webpackChunkName:"NightTimeOnDark" */ './NightTimeOnDark').then((mod) => mod.default)
);
export const Number1Dark = dynamic(() =>
	import(/* webpackChunkName:"Number1Dark" */ './Number1Dark').then((mod) => mod.default)
);
export const Number1Light = dynamic(() =>
	import(/* webpackChunkName:"Number1Light" */ './Number1Light').then((mod) => mod.default)
);
export const Number2Dark = dynamic(() =>
	import(/* webpackChunkName:"Number2Dark" */ './Number2Dark').then((mod) => mod.default)
);
export const Number2Light = dynamic(() =>
	import(/* webpackChunkName:"Number2Light" */ './Number2Light').then((mod) => mod.default)
);
export const Number3Dark = dynamic(() =>
	import(/* webpackChunkName:"Number3Dark" */ './Number3Dark').then((mod) => mod.default)
);
export const Number3Light = dynamic(() =>
	import(/* webpackChunkName:"Number3Light" */ './Number3Light').then((mod) => mod.default)
);
export const Number4Dark = dynamic(() =>
	import(/* webpackChunkName:"Number4Dark" */ './Number4Dark').then((mod) => mod.default)
);
export const Number4Light = dynamic(() =>
	import(/* webpackChunkName:"Number4Light" */ './Number4Light').then((mod) => mod.default)
);
export const Number5Dark = dynamic(() =>
	import(/* webpackChunkName:"Number5Dark" */ './Number5Dark').then((mod) => mod.default)
);
export const Number5Light = dynamic(() =>
	import(/* webpackChunkName:"Number5Light" */ './Number5Light').then((mod) => mod.default)
);
export const Number6Dark = dynamic(() =>
	import(/* webpackChunkName:"Number6Dark" */ './Number6Dark').then((mod) => mod.default)
);
export const Number6Light = dynamic(() =>
	import(/* webpackChunkName:"Number6Light" */ './Number6Light').then((mod) => mod.default)
);
export const Number7Dark = dynamic(() =>
	import(/* webpackChunkName:"Number7Dark" */ './Number7Dark').then((mod) => mod.default)
);
export const Number7Light = dynamic(() =>
	import(/* webpackChunkName:"Number7Light" */ './Number7Light').then((mod) => mod.default)
);
export const Number8Dark = dynamic(() =>
	import(/* webpackChunkName:"Number8Dark" */ './Number8Dark').then((mod) => mod.default)
);
export const Number8Light = dynamic(() =>
	import(/* webpackChunkName:"Number8Light" */ './Number8Light').then((mod) => mod.default)
);
export const Number9Dark = dynamic(() =>
	import(/* webpackChunkName:"Number9Dark" */ './Number9Dark').then((mod) => mod.default)
);
export const Number9Light = dynamic(() =>
	import(/* webpackChunkName:"Number9Light" */ './Number9Light').then((mod) => mod.default)
);

export const Number0SansDark = dynamic(() =>
	/* webpackChunkName: "Number0SansDark" */ import('./Number0SansDark').then((mod) => mod.default)
);
export const Number0SansLight = dynamic(() =>
	/* webpackChunkName: "Number0SansLight" */ import('./Number0SansLight').then((mod) => mod.default)
);
export const Number1SansDark = dynamic(() =>
	/* webpackChunkName: "Number1SansDark" */ import('./Number1SansDark').then((mod) => mod.default)
);
export const Number1SansLight = dynamic(() =>
	/* webpackChunkName: "Number1SansLight" */ import('./Number1SansLight').then((mod) => mod.default)
);
export const Number2SansDark = dynamic(() =>
	/* webpackChunkName: "Number2SansDark" */ import('./Number2SansDark').then((mod) => mod.default)
);
export const Number2SansLight = dynamic(() =>
	/* webpackChunkName: "Number2SansLight" */ import('./Number2SansLight').then((mod) => mod.default)
);
export const Number3SansDark = dynamic(() =>
	/* webpackChunkName: "Number3SansDark" */ import('./Number3SansDark').then((mod) => mod.default)
);
export const Number3SansLight = dynamic(() =>
	/* webpackChunkName: "Number3SansLight" */ import('./Number3SansLight').then((mod) => mod.default)
);
export const Number4SansDark = dynamic(() =>
	/* webpackChunkName: "Number4SansDark" */ import('./Number4SansDark').then((mod) => mod.default)
);
export const Number4SansLight = dynamic(() =>
	/* webpackChunkName: "Number4SansLight" */ import('./Number4SansLight').then((mod) => mod.default)
);

export const Number5SansDark = dynamic(() =>
	/* webpackChunkName: "Number5SansDark" */ import('./Number5SansDark').then((mod) => mod.default)
);
export const Number5SansLight = dynamic(() =>
	/* webpackChunkName: "Number5SansLight" */ import('./Number5SansLight').then((mod) => mod.default)
);
export const Number6SansDark = dynamic(() =>
	/* webpackChunkName: "Number6SansDark" */ import('./Number6SansDark').then((mod) => mod.default)
);
export const Number6SansLight = dynamic(() =>
	/* webpackChunkName: "Number6SansLight" */ import('./Number6SansLight').then((mod) => mod.default)
);
export const Number7SansDark = dynamic(() =>
	/* webpackChunkName: "Number7SansDark" */ import('./Number7SansDark').then((mod) => mod.default)
);
export const Number7SansLight = dynamic(() =>
	/* webpackChunkName: "Number7SansLight" */ import('./Number7SansLight').then((mod) => mod.default)
);
export const Number8SansDark = dynamic(() =>
	/* webpackChunkName: "Number8SansDark" */ import('./Number8SansDark').then((mod) => mod.default)
);
export const Number8SansLight = dynamic(() =>
	/* webpackChunkName: "Number8SansLight" */ import('./Number8SansLight').then((mod) => mod.default)
);
export const Number9SansDark = dynamic(() =>
	/* webpackChunkName: "Number9SansDark" */ import('./Number9SansDark').then((mod) => mod.default)
);
export const Number9SansLight = dynamic(() =>
	/* webpackChunkName: "Number9SansLight" */ import('./Number9SansLight').then((mod) => mod.default)
);

export const OccMed = dynamic(() => import(/* webpackChunkName:"OccMed" */ './OccMed').then((mod) => mod.default));
export const OneToothToAll = dynamic(() =>
	import(/* webpackChunkName:"OneToothToAll" */ './OneToothToAll').then((mod) => mod.default)
);
export const OneToothToAllOnDark = dynamic(() =>
	import(/* webpackChunkName:"OneToothToAllOnDark" */ './OneToothToAll').then((mod) => mod.default)
);
export const OnsiteLab = dynamic(() =>
	import(/* webpackChunkName:"OnsiteLab" */ './OnsiteLab').then((mod) => mod.default)
);
export const OnsiteLabOnDark = dynamic(() =>
	import(/* webpackChunkName:"OnsiteLabOnDark" */ './OnsiteLabOnDark').then((mod) => mod.default)
);
export const OnSitePrograms = dynamic(() =>
	import(/* webpackChunkName:"OnSitePrograms" */ './OnSitePrograms').then((mod) => mod.default)
);
export const PauseCircleOutlinedIcon = dynamic(() =>
	import(/* webpackChunkName:"PauseCircleOutlinedIcon" */ '@mui/icons-material/PauseCircleOutline').then(
		(mod) => mod.default
	)
);
export const PaymentOptions = dynamic(() =>
	import(/* webpackChunkName:"PaymentOptions" */ './PaymentOptions').then((mod) => mod.default)
);
export const PaymentOptionsOnDark = dynamic(() =>
	import(/* webpackChunkName:"PaymentOptionsOnDark" */ './PaymentOptions').then((mod) => mod.default)
);
export const Pediatrician = dynamic(() =>
	import(/* webpackChunkName:"Pediatrician" */ './Pediatrician').then((mod) => mod.default)
);
export const Percentage = dynamic(() =>
	import(/* webpackChunkName:"Percentage" */ './Percentage').then((mod) => mod.default)
);
export const PercentageOnDark = dynamic(() =>
	import(/* webpackChunkName:"PercentageOnDark" */ './PercentageOnDark').then((mod) => mod.default)
);
export const Phone = dynamic(() => import(/* webpackChunkName:"Phone" */ './Phone').then((mod) => mod.default));
export const Physicals = dynamic(() =>
	import(/* webpackChunkName:"Physicals" */ './Physicals').then((mod) => mod.default)
);
export const PlayCircleBtn = dynamic(() =>
	import(/* webpackChunkName:"PlayCircleBtn" */ './PlayCircleBtn').then((mod) => mod.default)
);
export const PlayCircleOutlinedIcon = dynamic(() =>
	import(/* webpackChunkName:"PlayCircleOutlinedIcon" */ '@mui/icons-material/PlayCircleOutline').then(
		(mod) => mod.default
	)
);
export const Plus = dynamic(() => import(/* webpackChunkName:"Plus" */ './Plus').then((mod) => mod.default));
export const PlusFunc = dynamic(() =>
	import(/* webpackChunkName:"PlusFunc" */ '@mui/icons-material/AddOutlined').then((mod) => mod.default)
);
export const PpeMask = dynamic(() => import(/* webpackChunkName:"PpeMask" */ './PpeMask').then((mod) => mod.default));
export const PremiumComfort = dynamic(() =>
	import(/* webpackChunkName:"PremiumComfort" */ './PremiumComfort').then((mod) => mod.default)
);
export const PriceMatch = dynamic(() =>
	import(/* webpackChunkName:"PriceMatch" */ './PriceMatch').then((mod) => mod.default)
);
export const PriceMatchDarkBlue = dynamic(() =>
	import(/* webpackChunkName:"PriceMatchDarkBlue" */ './PriceMatchDarkBlue').then((mod) => mod.default)
);
export const PriceMatchGreen = dynamic(() =>
	import(/* webpackChunkName:"PriceMatchGreen" */ './PriceMatchGreen').then((mod) => mod.default)
);
export const PriceMatchLightBlue = dynamic(() =>
	import(/* webpackChunkName:"PriceMatchLightBlue" */ './PriceMatchLightBlue').then((mod) => mod.default)
);
export const PriceMatchOnDark = dynamic(() =>
	import(/* webpackChunkName:"PriceMatchOnDark" */ './PriceMatch').then((mod) => mod.default)
);
export const QuestionCircle = dynamic(() =>
	import(/* webpackChunkName:"QuestionCircle" */ './QuestionCircle').then((mod) => mod.default)
);
export const Quotes = dynamic(() => import(/* webpackChunkName:"Quotes" */ './Quotes').then((mod) => mod.default));
export const Reddit = dynamic(() => import(/* webpackChunkName:"Reddit" */ './Reddit').then((mod) => mod.default));
export const RootCanal = dynamic(() =>
	import(/* webpackChunkName:"RootCanal" */ './RootCanal').then((mod) => mod.default)
);
export const Search = dynamic(() => import(/* webpackChunkName:"Search" */ './Search').then((mod) => mod.default));
export const SearchFunc = dynamic(() =>
	import(/* webpackChunkName:"SearchFunc" */ '@mui/icons-material/Search').then((mod) => mod.default)
);
export const Settings = dynamic(() =>
	import(/* webpackChunkName:"Settings" */ './Settings').then((mod) => mod.default)
);
export const SettingsFunc = dynamic(() =>
	import(/* webpackChunkName:"SettingsFunc" */ '@mui/icons-material/SettingsOutlined').then((mod) => mod.default)
);
export const ShowMoreArrowDown = dynamic(() =>
	import(/* webpackChunkName:"ShowMoreArrowDown" */ './ShowMoreArrowDown').then((mod) => mod.default)
);
export const Sink = dynamic(() => import(/* webpackChunkName:"Sink" */ './Sink').then((mod) => mod.default));
export const SinkOnDark = dynamic(() =>
	import(/* webpackChunkName:"SinkOnDark" */ './Sink').then((mod) => mod.default)
);
export const Smile = dynamic(() => import(/* webpackChunkName:"Smile" */ './Smile').then((mod) => mod.default));
export const SmileInHand = dynamic(() =>
	import(/* webpackChunkName:"SmileInHand" */ './SmileInHand').then((mod) => mod.default)
);
export const SmileInHandOnDark = dynamic(() =>
	import(/* webpackChunkName:"SmileInHandOnDark" */ './SmileInHandOnDark').then((mod) => mod.default)
);
export const SmileOnFile = dynamic(() =>
	import(/* webpackChunkName:"SmileOnFile" */ './SmileOnFile').then((mod) => mod.default)
);
export const SmileOnFileOnDark = dynamic(() =>
	import(/* webpackChunkName:"SmileOnFileOnDark" */ './SmileOnFileOnDark').then((mod) => mod.default)
);
export const SmoothShades = dynamic(() =>
	import(/* webpackChunkName:"SmoothShades" */ './SmoothShades').then((mod) => mod.default)
);
export const SomeoneElse = dynamic(() =>
	import(/* webpackChunkName:"SomeoneElse" */ './SomeoneElse').then((mod) => mod.default)
);
export const Sort = dynamic(() =>
	import(/* webpackChunkName:"Sort" */ '@mui/icons-material/UnfoldMoreOutlined').then((mod) => mod.default)
);
export const SortAscending = dynamic(() =>
	import(/* webpackChunkName:"SortAscending" */ './SortAscending').then((mod) => mod.default)
);
export const SortDescending = dynamic(() =>
	import(/* webpackChunkName:"SortDescending" */ './SortDescending').then((mod) => mod.default)
);
export const SortDown = dynamic(() =>
	import(/* webpackChunkName:"SortDown" */ '@mui/icons-material/KeyboardArrowDownOutlined').then((mod) => mod.default)
);
export const SortUp = dynamic(() =>
	import(/* webpackChunkName:"SortUp" */ '@mui/icons-material/KeyboardArrowUpOutlined').then((mod) => mod.default)
);
export const Soup = dynamic(() => import(/* webpackChunkName:"Soup" */ './Soup').then((mod) => mod.default));
export const SoupOnDark = dynamic(() =>
	import(/* webpackChunkName:"SoupOnDark" */ './Soup').then((mod) => mod.default)
);
export const SparkleTeeth = dynamic(() =>
	import(/* webpackChunkName:"SparkleTeeth" */ './SparkleTeeth').then((mod) => mod.default)
);
export const SparkleTeethOnDark = dynamic(() =>
	import(/* webpackChunkName:"SparkleTeethOnDark" */ './SparkleTeeth').then((mod) => mod.default)
);
export const Speak = dynamic(() => import(/* webpackChunkName:"Speak" */ './Speak').then((mod) => mod.default));
export const Square = dynamic(() => import(/* webpackChunkName:"Square" */ './Square').then((mod) => mod.default));
export const SquareFunc = dynamic(() =>
	import(/* webpackChunkName:"SquareFunc" */ '@mui/icons-material/CheckBoxOutlineBlankOutlined').then(
		(mod) => mod.default
	)
);
export const Star = dynamic(() =>
	import(/* webpackChunkName:"Star" */ '@mui/icons-material/StarBorderRounded').then((mod) => mod.default)
);
export const StarEmpty = dynamic(() =>
	import(/* webpackChunkName:"StarEmpty" */ './StarEmpty').then((mod) => mod.default)
);
export const StarFilled = dynamic(() =>
	import(/* webpackChunkName:"StarFilled" */ './StarFilled').then((mod) => mod.default)
);
export const StarIcon = dynamic(() =>
	import(/* webpackChunkName:"StarIcon" */ './StarIcon').then((mod) => mod.default)
);
export const StarHalfIcon = dynamic(() =>
	import(/* webpackChunkName:"StarHalfIcon" */ './StarHalfIcon').then((mod) => mod.default)
);
export const StarFull = dynamic(() =>
	import(/* webpackChunkName:"StarFull" */ '@mui/icons-material/StarRounded').then((mod) => mod.default)
);
export const StarredTooth = dynamic(() =>
	import(/* webpackChunkName:"StarredTooth" */ './StarredTooth').then((mod) => mod.default)
);
export const StarredToothOnDark = dynamic(() =>
	import(/* webpackChunkName:"StarredToothOnDark" */ './StarredTooth').then((mod) => mod.default)
);
export const StopWatch = dynamic(() =>
	import(/* webpackChunkName:"StopWatch" */ './StopWatch').then((mod) => mod.default)
);
export const StopWatchOnDark = dynamic(() =>
	import(/* webpackChunkName:"StopWatchOnDark" */ './StopWatch').then((mod) => mod.default)
);
export const SuccessCircle = dynamic(() =>
	import(/* webpackChunkName:"SuccessCircle" */ './SuccessCircle').then((mod) => mod.default)
);
export const Symptoms = dynamic(() =>
	import(/* webpackChunkName:"Symptoms" */ './Symptoms').then((mod) => mod.default)
);
export const Teeth = dynamic(() => import(/* webpackChunkName:"Teeth" */ './Teeth').then((mod) => mod.default));
export const TeethOpen = dynamic(() =>
	import(/* webpackChunkName:"TeethOpen" */ './TeethOpen').then((mod) => mod.default)
);
export const Threads = dynamic(() => import(/* webpackChunkName:"Threads" */ './Threads').then((mod) => mod.default));
export const ThumbsUp = dynamic(() =>
	import(/* webpackChunkName:"ThumbsUp" */ './ThumbsUp').then((mod) => mod.default)
);
export const ThumbsUpOnDark = dynamic(() =>
	import(/* webpackChunkName:"ThumbsUpOnDark" */ './ThumbsUp').then((mod) => mod.default)
);
export const Times = dynamic(() =>
	import(/* webpackChunkName:"Times" */ '@mui/icons-material/ClearOutlined').then((mod) => mod.default)
);
export const Tooth = dynamic(() => import(/* webpackChunkName:"Tooth" */ './Tooth').then((mod) => mod.default));
export const ToothBrush = dynamic(() =>
	import(/* webpackChunkName:"ToothBrush" */ './ToothBrush').then((mod) => mod.default)
);
export const ToothBrushOnDark = dynamic(() =>
	import(/* webpackChunkName:"ToothBrushOnDark" */ './ToothBrush').then((mod) => mod.default)
);
export const ToothPain = dynamic(() =>
	import(/* webpackChunkName:"ToothPain" */ './ToothPain').then((mod) => mod.default)
);
export const ToothRepair = dynamic(() =>
	import(/* webpackChunkName:"ToothRepair" */ './ToothRepair').then((mod) => mod.default)
);
export const ToothRepairOnDark = dynamic(() =>
	import(/* webpackChunkName:"ToothRepairOnDark" */ './ToothRepairOnDark').then((mod) => mod.default)
);
export const ToothToSmile = dynamic(() =>
	import(/* webpackChunkName:"ToothToSmile" */ './ToothToSmile').then((mod) => mod.default)
);
export const Trash = dynamic(() => import(/* webpackChunkName:"Trash" */ './Trash').then((mod) => mod.default));
export const TrashFunc = dynamic(() =>
	import(/* webpackChunkName:"TrashFunc" */ '@mui/icons-material/DeleteOutlineOutlined').then((mod) => mod.default)
);
export const Upload = dynamic(() => import(/* webpackChunkName:"Upload" */ './Upload').then((mod) => mod.default));
export const UploadFunc = dynamic(() =>
	import(/* webpackChunkName:"UploadFunc" */ '@mui/icons-material/UploadOutlined').then((mod) => mod.default)
);
export const UrgentCare = dynamic(() =>
	import(/* webpackChunkName:"UrgentCare" */ './UrgentCare').then((mod) => mod.default)
);
export const User = dynamic(() =>
	import(/* webpackChunkName:"User" */ '@mui/icons-material/PersonOutlineOutlined').then((mod) => mod.default)
);
export const Users = dynamic(() =>
	import(/* webpackChunkName:"Users" */ '@mui/icons-material/GroupsOutlined').then((mod) => mod.default)
);
export const VirtualCare = dynamic(() =>
	import(/* webpackChunkName:"VirtualCare" */ './VirtualCare').then((mod) => mod.default)
);
export const VirtualCareColorAlt = dynamic(() =>
	import(/* webpackChunkName:"VirtualCareColorAlt" */ './VirtualCareColorAlt').then((mod) => mod.default)
);
export const WarningCircle = dynamic(() =>
	import(/* webpackChunkName:"WarningCircle" */ './WarningCircle').then((mod) => mod.default)
);
export const Warranty = dynamic(() =>
	import(/* webpackChunkName:"Warranty" */ './Warranty').then((mod) => mod.default)
);
export const Warranty1DarkBlue = dynamic(() =>
	import(/* webpackChunkName:"Warranty1DarkBlue" */ './Warranty1DarkBlue').then((mod) => mod.default)
);
export const Warranty1Green = dynamic(() =>
	import(/* webpackChunkName:"Warranty1Green" */ './Warranty1Green').then((mod) => mod.default)
);
export const Warranty1LightBlue = dynamic(() =>
	import(/* webpackChunkName:"Warranty1LightBlue" */ './Warranty1LightBlue').then((mod) => mod.default)
);
export const Warranty3DarkBlue = dynamic(() =>
	import(/* webpackChunkName:"Warranty3DarkBlue" */ './Warranty3DarkBlue').then((mod) => mod.default)
);
export const Warranty3Green = dynamic(() =>
	import(/* webpackChunkName:"Warranty3Green" */ './Warranty3Green').then((mod) => mod.default)
);
export const Warranty3LightBlue = dynamic(() =>
	import(/* webpackChunkName:"Warranty3LightBlue" */ './Warranty3LightBlue').then((mod) => mod.default)
);
export const Warranty5DarkBlue = dynamic(() =>
	import(/* webpackChunkName:"Warranty5DarkBlue" */ './Warranty5DarkBlue').then((mod) => mod.default)
);
export const Warranty5Green = dynamic(() =>
	import(/* webpackChunkName:"Warranty5Green" */ './Warranty5Green').then((mod) => mod.default)
);
export const Warranty5LightBlue = dynamic(() =>
	import(/* webpackChunkName:"Warranty5LightBlue" */ './Warranty5LightBlue').then((mod) => mod.default)
);
export const Warranty7DarkBlue = dynamic(() =>
	import(/* webpackChunkName:"Warranty7DarkBlue" */ './Warranty7DarkBlue').then((mod) => mod.default)
);
export const Warranty7Green = dynamic(() =>
	import(/* webpackChunkName:"Warranty7Green" */ './Warranty7Green').then((mod) => mod.default)
);
export const Warranty7LightBlue = dynamic(() =>
	import(/* webpackChunkName:"Warranty7LightBlue" */ './Warranty7LightBlue').then((mod) => mod.default)
);
export const WarrantyDarkBlue = dynamic(() =>
	import(/* webpackChunkName:"WarrantyDarkBlue" */ './WarrantyDarkBlue').then((mod) => mod.default)
);
export const WarrantyGreen = dynamic(() =>
	import(/* webpackChunkName:"WarrantyGreen" */ './WarrantyGreen').then((mod) => mod.default)
);
export const WarrantyLightBlue = dynamic(() =>
	import(/* webpackChunkName:"WarrantyLightBlue" */ './WarrantyLightBlue').then((mod) => mod.default)
);
export const WarrantyOnDark = dynamic(() =>
	import(/* webpackChunkName:"WarrantyOnDark" */ './WarrantyOnDark').then((mod) => mod.default)
);
export const Water = dynamic(() => import(/* webpackChunkName:"Water" */ './Water').then((mod) => mod.default));
export const WaterOnDark = dynamic(() =>
	import(/* webpackChunkName:"WaterOnDark" */ './Water').then((mod) => mod.default)
);

export { default as WellNowMapPinDark } from './WellNowMapPinDark';
export { default as WellNowMapPinLight } from './WellNowMapPinLight';

export const TeamTagWellnowLogo = dynamic(() =>
	import(/* webpackChunkName:"WellNowOffice" */ './TeamTagWellnowLogo').then((mod) => mod.default)
);

export const WellnowBrandLogo = dynamic(() =>
	import(/* webpackChunkName:"AspenOffice" */ './WellnowBrandLogo').then((mod) => mod.default)
);

export const WellNowOffice = dynamic(() =>
	import(/* webpackChunkName:"WellNowOffice" */ './WellNowOffice').then((mod) => mod.default)
);
export const WellNowVirtualCare = dynamic(() =>
	import(/* webpackChunkName:"WellNowVirtualCare" */ './WellNowVirtualCare').then((mod) => mod.default)
);
export const WellNowVirtualCareAlt = dynamic(() =>
	import(/* webpackChunkName:"WellNowVirtualCareAlt" */ './WellNowVirtualCareAlt').then((mod) => mod.default)
);
export const WisdomTeeth = dynamic(() =>
	import(/* webpackChunkName:"WisdomTeeth" */ './WisdomTeeth').then((mod) => mod.default)
);
export const WNGastrointestinal = dynamic(() =>
	import(/* webpackChunkName:"WNGastrointestinal" */ './WNGastrointestinal').then((mod) => mod.default)
);
export const WNRespiratory = dynamic(() =>
	import(/* webpackChunkName:"WNRespiratory" */ './WNRespiratory').then((mod) => mod.default)
);
export const WNTesting = dynamic(() =>
	import(/* webpackChunkName:"WNTesting" */ './WNTesting').then((mod) => mod.default)
);
export const XCompany = dynamic(() =>
	import(/* webpackChunkName:"XCompany" */ './XCompany').then((mod) => mod.default)
);
export const XmarkDefault = dynamic(() =>
	import(/* webpackChunkName:"XmarkDefault" */ './XmarkDefault').then((mod) => mod.default)
);
export const XRay = dynamic(() => import(/* webpackChunkName:"XRay" */ './XRay').then((mod) => mod.default));
export const Yourself = dynamic(() =>
	import(/* webpackChunkName:"Yourself" */ './Yourself').then((mod) => mod.default)
);
export const Youtube = dynamic(() => import(/* webpackChunkName:"Youtube" */ './Youtube').then((mod) => mod.default));
export const Work = dynamic(() =>
	import(/* webpackChunkName:"Work" */ '@mui/icons-material/Work').then((mod) => mod.default)
);
export const Verified = dynamic(() =>
	import(/* webpackChunkName:"Verified" */ '@mui/icons-material/Verified').then((mod) => mod.default)
);
export const LocationOn = dynamic(() =>
	import(/* webpackChunkName:"LocationOn" */ '@mui/icons-material/LocationOn').then((mod) => mod.default)
);
export const Language = dynamic(() =>
	import(/* webpackChunkName:"Language" */ '@mui/icons-material/Language').then((mod) => mod.default)
);
export const VolunteerActivism = dynamic(() =>
	import(/* webpackChunkName:"VolunteerActivism" */ '@mui/icons-material/VolunteerActivism').then(
		(mod) => mod.default
	)
);
export const CloseFunc = dynamic(() =>
	import(/* webpackChunkName:"CloseFunc" */ '@mui/icons-material/Close').then((mod) => mod.default)
);
export const LocationOnOutlined = dynamic(() =>
	import(/* webpackChunkName:"LocationOnOutlined" */ '@mui/icons-material/LocationOnOutlined').then(
		(mod) => mod.default
	)
);
export const MenuBookIcon = dynamic(() =>
	import(/* webpackChunkName:"MenuBookIcon" */ '@mui/icons-material/MenuBook').then((mod) => mod.default)
);
export const CameraAlt = dynamic(() =>
	import(/* webpackChunkName:"CameraAlt" */ '@mui/icons-material/CameraAlt').then((mod) => mod.default)
);
export const QrCode2 = dynamic(() =>
	import(/* webpackChunkName:"QrCode2" */ '@mui/icons-material/QrCode2').then((mod) => mod.default)
);
export const InsertPhoto = dynamic(() =>
	import(/* webpackChunkName:"InsertPhoto" */ '@mui/icons-material/InsertPhoto').then((mod) => mod.default)
);
export const FileUploadOutlined = dynamic(() =>
	import(/* webpackChunkName:"FileUploadOutlined" */ '@mui/icons-material/FileUploadOutlined').then(
		(mod) => mod.default
	)
);
export const CircleTwoTone = dynamic(() =>
	import(/* webpackChunkName:"CircleTwoTone" */ '@mui/icons-material/CircleTwoTone').then((mod) => mod.default)
);
export const Info = dynamic(() =>
	import(/* webpackChunkName:"Info" */ '@mui/icons-material/Info').then((mod) => mod.default)
);
export const East = dynamic(() =>
	import(/* webpackChunkName:"East" */ '@mui/icons-material/East').then((mod) => mod.default)
);
export const NoPhotography = dynamic(() =>
	import(/* webpackChunkName:"NoPhotography" */ '@mui/icons-material/NoPhotography').then((mod) => mod.default)
);
export const PrivacyOptions = dynamic(() =>
	import(/* webpackChunkName:"PrivacyOptions" */ './PrivacyOptions').then((mod) => mod.default)
);

export const EcgHeart = dynamic(() =>
	/* webpackChunkName: "EcgHeart" */ import('./EcgHeart').then((mod) => mod.default)
);
export const Pets = dynamic(() =>
	/* webpackChunkName: "Pets" */ import('@mui/icons-material/Pets').then((mod) => mod.default)
);
export const ArrowRightAlt = dynamic(() =>
	/* webpackChunkName: "ArrowRightAlt" */ import('@mui/icons-material/ArrowRightAlt').then((mod) => mod.default)
);
export const NewReleasesOutlined = dynamic(() =>
	/* webpackChunkName: "NewReleasesOutlined" */ import('@mui/icons-material/NewReleasesOutlined').then(
		(mod) => mod.default
	)
);
export const MailOutlined = dynamic(() =>
	/* webpackChunkName: "MailOutlined" */ import('@mui/icons-material/MailOutlined').then((mod) => mod.default)
);
export const CallOutlined = dynamic(() =>
	/* webpackChunkName: "CallOutlined" */ import('@mui/icons-material/CallOutlined').then((mod) => mod.default)
);
export const DirectionsCarOutlined = dynamic(() =>
	/* webpackChunkName: "DirectionsCarOutlined" */ import('@mui/icons-material/DirectionsCarOutlined').then(
		(mod) => mod.default
	)
);
export const NearMeOutlined = dynamic(() =>
	/* webpackChunkName: "NearMeOutlined" */ import('@mui/icons-material/NearMeOutlined').then((mod) => mod.default)
);
export const AddLocationAltOutlined = dynamic(() =>
	/* webpackChunkName: "AddLocationAltOutlined" */ import('@mui/icons-material/AddLocationAltOutlined').then(
		(mod) => mod.default
	)
);
export const MedicalServicesOutlined = dynamic(() =>
	/* webpackChunkName: "MedicalServicesOutlined" */ import('@mui/icons-material/MedicalServicesOutlined').then(
		(mod) => mod.default
	)
);
export const VaccinesOutlined = dynamic(() =>
	/* webpackChunkName: "VaccinesOutlined" */ import('@mui/icons-material/VaccinesOutlined').then((mod) => mod.default)
);
export const PestControlOutlined = dynamic(() =>
	/* webpackChunkName: "PestControlOutlined" */ import('@mui/icons-material/PestControlOutlined').then(
		(mod) => mod.default
	)
);
export const SpaOutlined = dynamic(() =>
	/* webpackChunkName: "SpaOutlined" */ import('@mui/icons-material/SpaOutlined').then((mod) => mod.default)
);
export const CreditCardHeart = dynamic(() =>
	/* webpackChunkName: "CreditCardHeart" */ import('./CreditCardHeart').then((mod) => mod.default)
);
export const Stethoscope = dynamic(() =>
	/* webpackChunkName: "Stethoscope" */ import('./Stethoscope').then((mod) => mod.default)
);
export const Syringe = dynamic(() => /* webpackChunkName: "Syringe" */ import('./Syringe').then((mod) => mod.default));
export const Hematology = dynamic(() =>
	/* webpackChunkName: "Hematology" */ import('./Hematology').then((mod) => mod.default)
);
export const MemoryAlt = dynamic(() =>
	/* webpackChunkName: "MemoryAlt" */ import('./MemoryAlt').then((mod) => mod.default)
);
export const Prescriptions = dynamic(() =>
	/* webpackChunkName: "Prescriptions" */ import('./Prescriptions').then((mod) => mod.default)
);
export const TransitTicket = dynamic(() =>
	/* webpackChunkName: "TransitTicket" */ import('./TransitTicket').then((mod) => mod.default)
);
export const Nutrition = dynamic(() =>
	/* webpackChunkName: "Nutrition" */ import('./Nutrition').then((mod) => mod.default)
);
export const EmergencyMaterial = dynamic(() =>
	/* webpackChunkName: "EmergencyMaterial" */ import('./EmergencyMaterial').then((mod) => mod.default)
);
export const CoronavirusOutlined = dynamic(() =>
	/* webpackChunkName: "CoronavirusOutlined" */ import('@mui/icons-material/CoronavirusOutlined').then(
		(mod) => mod.default
	)
);
export const E911Emergency = dynamic(() =>
	/* webpackChunkName: "E911Emergency" */ import('./E911Emergency').then((mod) => mod.default)
);
export const Radiology = dynamic(() =>
	/* webpackChunkName: "Radiology" */ import('./Radiology').then((mod) => mod.default)
);
export const Deceased = dynamic(() =>
	/* webpackChunkName: "Deceased" */ import('./Deceased').then((mod) => mod.default)
);
export const Fluid = dynamic(() => /* webpackChunkName: "Fluid" */ import('./Fluid').then((mod) => mod.default));
export const BedOutlined = dynamic(() =>
	/* webpackChunkName: "BedOutlined" */ import('@mui/icons-material/BedOutlined').then((mod) => mod.default)
);
export const Surgical = dynamic(() =>
	/* webpackChunkName: "Surgical" */ import('./Surgical').then((mod) => mod.default)
);
export const HealingOutlined = dynamic(() =>
	/* webpackChunkName: "HealingOutlined" */ import('@mui/icons-material/HealingOutlined').then((mod) => mod.default)
);
export const Dentistry = dynamic(() =>
	/* webpackChunkName: "Dentistry" */ import('./Dentistry').then((mod) => mod.default)
);
export const Orthopedics = dynamic(() =>
	/* webpackChunkName: "Orthopedics" */ import('./Orthopedics').then((mod) => mod.default)
);
export const WoundsInjuries = dynamic(() =>
	/* webpackChunkName: "WoundsInjuries" */ import('./WoundsInjuries').then((mod) => mod.default)
);
export const Mystery = dynamic(() => /* webpackChunkName: "Mystery" */ import('./Mystery').then((mod) => mod.default));
export const MonitorHeartOutlined = dynamic(() =>
	/* webpackChunkName: "MonitorHeartOutlined" */ import('@mui/icons-material/MonitorHeartOutlined').then(
		(mod) => mod.default
	)
);
export const SelfCare = dynamic(() =>
	/* webpackChunkName: "SelfCare" */ import('./SelfCare').then((mod) => mod.default)
);
export const Raven = dynamic(() => /* webpackChunkName: "Raven" */ import('./Raven').then((mod) => mod.default));
export const GraphicEq = dynamic(() =>
	/* webpackChunkName: "GraphicEq" */ import('@mui/icons-material/GraphicEq').then((mod) => mod.default)
);
export const Atr = dynamic(() => /* webpackChunkName: "Atr" */ import('./Atr').then((mod) => mod.default));
export const AcUnit = dynamic(() =>
	/* webpackChunkName: "AcUnit" */ import('@mui/icons-material/AcUnit').then((mod) => mod.default)
);
export const SanitizerOutlined = dynamic(() =>
	/* webpackChunkName: "SanitizerOutlined" */ import('@mui/icons-material/SanitizerOutlined').then(
		(mod) => mod.default
	)
);
export const Pill = dynamic(() => /* webpackChunkName: "Pill" */ import('./Pill').then((mod) => mod.default));
export const Sunny = dynamic(() => /* webpackChunkName: "Sunny" */ import('./Sunny').then((mod) => mod.default));
export const Ecg = dynamic(() => /* webpackChunkName: "Ecg" */ import('./Ecg').then((mod) => mod.default));
export const WorkspacePremiumOutlined = dynamic(() =>
	/* webpackChunkName: "WorkspacePremiumOutlined" */ import('@mui/icons-material/WorkspacePremiumOutlined').then(
		(mod) => mod.default
	)
);
export const Oncology = dynamic(() =>
	/* webpackChunkName: "Oncology" */ import('./Oncology').then((mod) => mod.default)
);
export const Timelapse = dynamic(() =>
	/* webpackChunkName: "Timelapse" */ import('@mui/icons-material/Timelapse').then((mod) => mod.default)
);
export const SoundDetectionDogBarking = dynamic(() =>
	/* webpackChunkName: "SoundDetectionDogBarking" */ import('./SoundDetectionDogBarking').then((mod) => mod.default)
);
export const CrueltyFree = dynamic(() =>
	/* webpackChunkName: "CrueltyFree" */ import('./CrueltyFree').then((mod) => mod.default)
);
export const LVLovetV = dynamic(() =>
	/* webpackChunkName: "LVLovetV" */ import('./loveticons/LVLovetV').then((mod) => mod.default)
);
export const LVLovetVLight = dynamic(() =>
	/* webpackChunkName: "LVLovetVLight" */ import('./loveticons/LVLovetVLight').then((mod) => mod.default)
);
export const LVHernia = dynamic(() =>
	/* webpackChunkName: "LVHernia" */ import('./loveticons/LVHernia').then((mod) => mod.default)
);
export const LVSpleen = dynamic(() =>
	/* webpackChunkName: "LVSpleen" */ import('./loveticons/LVSpleen').then((mod) => mod.default)
);
export const LVForeignBodyRemoval = dynamic(() =>
	/* webpackChunkName: "LVForeignBodyRemoval" */ import('./loveticons/LVForeignBodyRemoval').then(
		(mod) => mod.default
	)
);
export const LVCatMaterial = dynamic(() =>
	/* webpackChunkName: "LVCatMaterial" */ import('./loveticons/LVCatMaterial').then((mod) => mod.default)
);
export const LVLizard = dynamic(() =>
	/* webpackChunkName: "LVLizard" */ import('./loveticons/LVLizard').then((mod) => mod.default)
);
export const LVInstagram = dynamic(() =>
	/* webpackChunkName: "LVInstagram" */ import('./loveticons/LVInstagram').then((mod) => mod.default)
);
export const LVFacebook = dynamic(() =>
	/* webpackChunkName: "LVFacebook" */ import('./loveticons/LVFacebook').then((mod) => mod.default)
);
export const LVLinkedin = dynamic(() =>
	/* webpackChunkName: "LVLinkedin" */ import('./loveticons/LVLinkedin').then((mod) => mod.default)
);
export const LVTikTok = dynamic(() =>
	/* webpackChunkName: "LVTikTok" */ import('./loveticons/LVTikTok').then((mod) => mod.default)
);

export const SelfImprovement = dynamic(() =>
	/* webpackChunkName: "SelfImprovement" */ import('@mui/icons-material/SelfImprovementOutlined').then(
		(mod) => mod.default
	)
);
export const StarCircle = dynamic(() =>
	/* webpackChunkName: "StarCircle" */ import('./StarCircle').then((mod) => mod.default)
);
export const PiggyBank = dynamic(() =>
	/* webpackChunkName: "PiggyBank" */ import('@mui/icons-material/SavingsOutlined').then((mod) => mod.default)
);

export const FocusTarget = dynamic(() =>
	/* webpackChunkName: "FocusTarget" */ import('./FocusTraget').then((mod) => mod.default)
);

export const LVLocationArrow = dynamic(() =>
	/* webpackChunkName: "LVLocationArrow" */ import('./loveticons/LVLocationArrow').then((mod) => mod.default)
);

export const West = dynamic(() =>
	import(/* webpackChunkName:"West" */ '@mui/icons-material/West').then((mod) => mod.default)
);
export const RemoveCircleOutlineOutlined = dynamic(() =>
	import(/* webpackChunkName:"RemoveCircleOutlineOutlined" */ '@mui/icons-material/RemoveCircleOutlineOutlined').then(
		(mod) => mod.default
	)
);
export const CircleRounded = dynamic(() =>
	import(/* webpackChunkName:"CircleRounded" */ '@mui/icons-material/CircleRounded').then((mod) => mod.default)
);
export const Dog = dynamic(() => import(/* webpackChunkName:"Dog" */ './Dog').then((mod) => mod.default));
export const Diagnosis = dynamic(() =>
	import(/* webpackChunkName:"Diagnosis" */ './Diagnosis').then((mod) => mod.default)
);
export const OtherAnimal = dynamic(() =>
	import(/* webpackChunkName:"OtherAnimal" */ './OtherAnimal').then((mod) => mod.default)
);
export const Cat = dynamic(() => import(/* webpackChunkName:"Cat" */ './Cat').then((mod) => mod.default));
export const DentalCleaning = dynamic(() =>
	import(/* webpackChunkName:"DentalCleaning" */ './DentalCleaning').then((mod) => mod.default)
);
export const LVDentalExam = dynamic(() =>
	import(/* webpackChunkName:"LVDentalExam" */ './loveticons/LVDentalExam').then((mod) => mod.default)
);
export const LVDentalExtraction = dynamic(() =>
	import(/* webpackChunkName:"LVDentalExtraction" */ './loveticons/LVDentalExtraction').then((mod) => mod.default)
);
export const Dentures_RV = dynamic(() =>
	import(/* webpackChunkName:"Dentures_RV" */ './DenturesRFV').then((mod) => mod.default)
);
export const DentalImplants_RV = dynamic(() =>
	import(/* webpackChunkName:"DentalImplants_RV" */ './DentalImplantsRFV').then((mod) => mod.default)
);
export const MottoAligners_RV = dynamic(() =>
	import(/* webpackChunkName:"MottoAligners_RV" */ './MottoAlignersRFV').then((mod) => mod.default)
);
export const Emergency_RV = dynamic(() =>
	import(/* webpackChunkName:"Emergency_RV" */ './EmergencyRFV').then((mod) => mod.default)
);
export const BrokenTooth_RV = dynamic(() =>
	import(/* webpackChunkName:"BrokenTooth_RV" */ './BrokenToothRFV').then((mod) => mod.default)
);
export const Other_RV = dynamic(() =>
	import(/* webpackChunkName:"Other_RV" */ './OtherRFV').then((mod) => mod.default)
);
export const LVFavorite = dynamic(() =>
	import(/* webpackChunkName:"LVFavorite" */ './loveticons/LVFavorite').then((mod) => mod.default)
);
export const LVClips = dynamic(() =>
	import(/* webpackChunkName:"LVClips" */ './loveticons/LVClips').then((mod) => mod.default)
);
export const LVWater = dynamic(() =>
	import(/* webpackChunkName:"LVWater" */ './loveticons/LVWater').then((mod) => mod.default)
);
export const LVBeauty = dynamic(() =>
	import(/* webpackChunkName:"LVBeauty" */ './loveticons/LVBeauty').then((mod) => mod.default)
);
